import StorageEnvironmentList from '@/components/StorageEnvironment/StorageEnvironmentList'
import StorageEnvironmentForm from '@/components/StorageEnvironment/StorageEnvironmentForm'
import StorageEnvironmentDetail from '@/components/StorageEnvironment/StorageEnvironmentDetail'

let StorageEnvironmentRouter = [{
  path: '/storage_environment',
  name: 'StorageEnvironmentList',
  component: StorageEnvironmentList,
  meta: {
    title: 'Environnements de stockage',
    requiresAuth: true,
    authorizations: ['storage-environment_index', 'desktop_access']
  }
}, {
  path: '/storage_environment/new',
  name: 'StorageEnvironmentNew',
  component: StorageEnvironmentForm,
  meta: {
    title: 'Nouvel environnement de stockage',
    requiresAuth: true,
    authorizations: ['storage-environment_new', 'desktop_access']
  }
}, {
  path: '/storage_environment/:id/edit',
  name: 'StorageEnvironmentEdit',
  component: StorageEnvironmentForm,
  meta: {
    title: 'Modifier un environnement de stockage',
    requiresAuth: true,
    authorizations: ['storage-environment_edit', 'desktop_access']
  }
}, {
  path: '/storage_environment/:id',
  name: 'StorageEnvironmentDetail',
  component: StorageEnvironmentDetail,
  meta: {
    title: 'Fiche environnement de stockage',
    requiresAuth: true,
    authorizations: ['storage-environment_show', 'desktop_access']
  }
}]

export default StorageEnvironmentRouter



// WEBPACK FOOTER //
// ./src/components/StorageEnvironment/router.js